import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import { motion } from 'framer-motion';
import api from '../services/api';
import Loader from '../components/Loader';
import Button from '../components/Button';
import BoletoModal from '../components/BoletoModal';
import NotaModal from '../components/NotaModal';
import ChequeModal from '../components/ChequeModal';
import ConfirmModal from '../components/ConfirmModal';
import InutilizacaoModal from '../components/InutilizacaoModal';

const instancia = process.env.REACT_APP_INSTANCIA;
const url_backend = process.env.REACT_APP_API_BACKEND;

const HomeContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f5f5f7;
`;

const HomeHeader = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
`;

const Logo = styled.h1`
  font-size: 24px;
  color: #6c5ce7;
`;

const UserSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const UserAvatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #6c5ce7;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
`;

const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const UserName = styled.span`
  font-weight: 600;
  font-size: 14px;
`;

const LogoutButton = styled.button`
  background: none;
  border: none;
  color: #666;
  font-size: 13px;
  cursor: pointer;
  transition: color 0.3s;
  
  &:hover {
    color: #e74c3c;
  }
`;

const ContentContainer = styled.div`
  flex: 1;
  padding: 24px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
`;

const StatusCardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
`;

const StatusCard = styled(motion.div)`
  background-color: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
`;

const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;

const CardTitle = styled.h3`
  font-size: 14px;
  color: #666;
  font-weight: 500;
`;

const CardIcon = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.bgColor || '#e6e6fa'};
  color: ${props => props.iconColor || '#6c5ce7'};
`;

const CardValue = styled.h2`
  font-size: 24px;
  margin-bottom: 4px;
`;

const CardDescription = styled.p`
  font-size: 13px;
  color: #666;
`;

const TabsContainer = styled.div`
  display: flex;
  margin-bottom: 24px;
  border-bottom: 1px solid #e1e1e1;
`;

const Tab = styled.button`
  padding: 12px 24px;
  background: none;
  border: none;
  font-size: 16px;
  font-weight: ${props => (props.active ? '600' : '400')};
  color: ${props => (props.active ? '#6c5ce7' : '#666')};
  position: relative;
  cursor: pointer;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: ${props => (props.active ? '#6c5ce7' : 'transparent')};
    border-radius: 3px 3px 0 0;
  }
`;

const SectionHeading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

const SectionTitle = styled.h2`
  font-size: 18px;
  color: #333;
`;

const FilterSection = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const SearchInput = styled.input`
  padding: 8px 12px;
  border: 1px solid #e1e1e1;
  border-radius: 8px;
  font-size: 14px;
  
  &:focus {
    outline: none;
    border-color: #6c5ce7;
  }
`;

const AdvancedFiltersButton = styled.button`
  background: none;
  border: none;
  color: #6c5ce7;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  
  &:hover {
    text-decoration: underline;
  }
`;

const AdvancedFiltersContainer = styled.div`
  background-color: #f9f9fb;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  display: ${props => (props.show ? 'grid' : 'none')};
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const FilterLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: #666;
  margin-bottom: 4px;
`;

const SelectFilter = styled.select`
  padding: 8px 12px;
  border: 1px solid #e1e1e1;
  border-radius: 8px;
  background-color: white;
  font-size: 14px;
  
  &:focus {
    outline: none;
    border-color: #6c5ce7;
  }
`;

const TableContainer = styled.div`
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  overflow: hidden;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const Th = styled.th`
  text-align: left;
  padding: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #666;
  background-color: #f9f9f9;
  border-bottom: 1px solid #e1e1e1;
`;

const Td = styled.td`
  padding: 5px;
  font-size: 14px;
  border-bottom: 1px solid #e1e1e1;
`;

const StatusBadge = styled.span`
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  background-color: ${props => {
    switch (props.status) {
      case 'Pago':
      case 'Concluído':
        return '#e6f7ed';
      case 'Pendente':
      case 'Em processamento':
        return '#fff8e6';
      case 'Atrasado':
      case 'Cancelado':
        return '#fee6e6';
      default:
        return '#e6e6fa';
    }
  }};
  color: ${props => {
    switch (props.status) {
      case 'Pago':
      case 'Concluído':
        return '#2ecc71';
      case 'Pendente':
      case 'Em processamento':
        return '#f39c12';
      case 'Atrasado':
      case 'Cancelado':
        return '#e74c3c';
      default:
        return '#6c5ce7';
    }
  }};
`;

const ActionButton = styled.button`
  background: none;
  border: none;
  color: #6c5ce7;
  font-size: 14px;
  cursor: pointer;
  padding: 5px 10px;
  margin-right: 5px;
  border-radius: 4px;
  transition: background-color 0.3s;
  
  &:hover {
    background-color: rgba(108, 92, 231, 0.1);
  }
`;

const FilterButton = styled.button`
  padding: 8px 12px;
  background-color: ${props => props.active ? '#6c5ce7' : 'white'};
  color: ${props => props.active ? 'white' : '#666'};
  border: 1px solid ${props => props.active ? '#6c5ce7' : '#e1e1e1'};
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
  
  &:hover {
    background-color: ${props => props.active ? '#5d4adb' : '#f5f5f7'};
  }
`;

const FiltersContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
`;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-top: 1px solid #e1e1e1;
`;

const PaginationInfo = styled.span`
  font-size: 14px;
  color: #666;
`;

const PaginationButtons = styled.div`
  display: flex;
  gap: 8px;
`;

const PaginationButton = styled.button`
  padding: 6px 12px;
  background-color: ${props => (props.active ? '#6c5ce7' : 'white')};
  color: ${props => (props.active ? 'white' : '#666')};
  border: 1px solid ${props => (props.active ? '#6c5ce7' : '#e1e1e1')};
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s;
  
  &:hover {
    background-color: ${props => (props.active ? '#6c5ce7' : '#f5f5f7')};
  }
  
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 40px;
  color: #666;
`;

const ActionButtonGroup = styled.div`
  display: flex;
  gap: 8px;
`;

const girar = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: bold;
  color: #444;
  margin-top: 10px;
`;

const Spinner = styled.div`
  width: 16px;
  height: 16px;
  border: 3px solid #bbb;
  border-top-color: #3498db;
  border-radius: 50%;
  animation: ${girar} 0.8s linear infinite;
`;

const Home = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('pedidos');
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [userData, setUserData] = useState(null);
  const [selectedPeriodo, setSelectedPeriodo] = useState('hoje');
  const [selectedStatus, setSelectedStatus] = useState('todos');
  const [selectedCondicaoPagamento, setSelectedCondicaoPagamento] = useState('todas');
  const [selectedVendedor, setSelectedVendedor] = useState('todos');
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  const [vendedores, setVendedores] = useState([]);
  const [condicoesPagamento, setCondicoesPagamento] = useState([]);
  const [tipos, setTipos] = useState([
    { id: 1, descricao: 'TODOS' },
    { id: 2, descricao: 'NFE' },
    { id: 3, descricao: 'NFCE' },
    { id: 4, descricao: 'PEDIDOS' },
    { id: 5, descricao: 'CANCELADA' },
  ]);

  const [selectedTipo, setSelectedTipo] = useState('TODOS');

  const [isBoletoModalOpen, setIsBoletoModalOpen] = useState(false);
  const [selectedPedidoId, setSelectedPedidoId] = useState(null);

  const [isChequeModalOpen, setIsChequeModalOpen] = useState(false);
  const [currentCheque, setCurrentCheque] = useState(null); // Para edição

  const [isInutilizacaoModalOpen, setIsInutilizacaoModalOpen] = useState(false);

  const [totalCheque, setTotalCheque] = useState(0);

  // Estados para armazenar os dados
  const [summaryData, setSummaryData] = useState({
    pedidosAbertos: 0,
    pedidosConcluidos: 0,
    docsFiscais: 0,
    notasFiscais: 0,
    valorTotal: 0,
    chequesAbertos: 0,
    chequesBaixados: 0,
    totalCheques: 0
  });

  const [pedidos, setPedidos] = useState([]);
  const [boletos, setBoletos] = useState([]);
  const [cheques, setCheques] = useState([]);
  const [notasFiscais, setNotasFiscais] = useState([]);

  const [isNotaModalOpen, setIsNotaModalOpen] = useState(false);
  const [selectedNota, setSelectedNota] = useState(null);
  const [modalOperacao, setModalOperacao] = useState('');

  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);
  const [confirmMessage, setConfirmMessage] = useState('');
  const [confirmResult, setConfirmResult] = useState(null); // true = sim, false = não

  const [carregandoZip, setCarregandoZip] = useState(false);

  const [selectedPedidos, setSelectedPedidos] = useState([]);
  const [selectedBoletos, setSelectedBoletos] = useState([]);
  const [selectedNotasFiscais, setSelectedNotasFiscais] = useState([]);
  const [selectedCheques, setSelectedCheques] = useState([]);

  const [dataI, setDataI] = useState("");
  const [dataF, setDataF] = useState("");

  const [isFiscal, setIsFiscal] = useState("N");

  // Carregar dados iniciais
  useEffect(() => {
    (async () => {

      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/');
        return;
      }

      if (!selectedPeriodo) { return; }

      // Simulação de carregamento de dados do usuário
      setUserData({
        nome: localStorage.getItem('nomeUsuarioLogado'),
        email: localStorage.getItem('emailUsuarioLogado'),
        iniciais: localStorage.getItem('iniciaisUsuarioLogado')
      });

      // Carregar condições de pagamento
      // Em um cenário real: const condicoesResponse = await api.get('/condicoes-pagamento');
      setCondicoesPagamento([
        { id: 1, nome: 'A VISTA' },
        { id: 3, nome: 'A PRAZO' },
      ]);

      await fetchVendedores();

      // Buscar pedidos iniciais
      await fetchPedidos({
        periodo: selectedPeriodo,
        status: selectedStatus,
        condicaoPagamento: selectedCondicaoPagamento,
        vendedor: selectedVendedor,
        tipo: selectedTipo === 'PEDIDOS' ? 'N' : selectedTipo,
        fiscal: isFiscal || 'N'
      });

      // Buscar cheques 
      await fetchCheques({
        selectedPeriodo,
        status: selectedStatus
      });

    })();
  }, [navigate]);

  // Efeito para atualizar quando os filtros mudarem
  useEffect(() => {
    (async () => {
      if (activeTab === 'pedidos') {
        await fetchPedidos({
          periodo: selectedPeriodo,
          status: selectedStatus,
          condicaoPagamento: selectedCondicaoPagamento,
          vendedor: selectedVendedor,
          tipo: selectedTipo === 'PEDIDOS' ? 'N' : selectedTipo,
          fiscal: isFiscal || 'N'
        });
      }
      if (activeTab === 'boletos') {
        setCurrentPage(1);
        let boletosFiltro = [];
        for (const pedido of pedidos) {
          if (pedido.temBoleto) {
            boletosFiltro.push({
              id: pedido.COD_PEDIDO, // Supondo que 'ID' seja uma propriedade do pedido
              numero: String(pedido.COD_PEDIDO), // Gerando um número baseado no ID do pedido
              pedido: String(pedido.COD_PEDIDO), // Supondo que 'PEDIDO' seja uma propriedade do pedido
              cliente: pedido.NOME, // Supondo que 'CLIENTE' seja uma propriedade do pedido
              valor: Number(pedido.VALOR_TOTAL), // Supondo que 'VALOR_TOTAL' seja o valor do pedido
              vencimento: pedido.DATA_PEDIDO, // Supondo que 'VENCIMENTO' seja uma propriedade do pedido
              status: pedido.STATUS // Pode ser ajustado conforme necessário
            });
          }
        }
        setBoletos(boletosFiltro);
      }

      if (activeTab === 'notasFiscais') {
        setCurrentPage(1);
        let notasFiltro = []
        for (const pedido of pedidos) {
          if (pedido.TIPO_DOC_FISCAL !== 'N') {
            notasFiltro.push({
              id: pedido.COD_PEDIDO,
              numero: String(pedido.NUMERO_NOTA),
              pedido: String(pedido.COD_PEDIDO),
              cliente: pedido.NOME,
              valor: pedido.VALOR_TOTAL,
              emissao: pedido.DATA_PEDIDO,
              status: pedido.STATUS,
              tipo_doc: pedido.TIPO_DOC_FISCAL,
              url_consulta: pedido.URL_CONSULTA,
              pdfNf: pedido.PDFNFCe,
              caminhoXml: pedido.XMLNFCe,
              caminhoPdf: pedido.CAMINHO_PDF,
              chave_nfe: pedido.CHAVE_NFE,
              caminhoXmlAbsoluto: pedido.CAMINHO_XML,
              email: pedido.EMAIL || 'nfe1.furlan@gmail.com'
            });
          }
        }
        setNotasFiscais(notasFiltro);
      }

      if (activeTab === 'cheques') {
        await fetchCheques({
          selectedPeriodo,
          status: selectedStatus
        });
      }
    })();
  }, [selectedPeriodo, selectedStatus, selectedCondicaoPagamento, selectedVendedor, activeTab, selectedTipo, isFiscal]);

  // Função para formatar valores em Real (R$)
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  };

  // function formatDateFiltro(dt) {
  //   const originalDate = dt;
  //   const formattedDate = new Date(originalDate).toISOString().slice(0, 19).replace('T', ' ');
  //   dt = formattedDate;
  //   return dt;
  // }

  function formatDate(dt) {

    const originalDate = dt;
    const formattedDate = new Date(originalDate).toISOString().slice(0, 19).replace('T', ' ');
    dt = formattedDate;

    const originalDate2 = new Date(dt);
    const day = String(originalDate2.getDate()).padStart(2, '0'); // Pega o dia e adiciona zero à esquerda, se necessário
    const month = String(originalDate2.getMonth() + 1).padStart(2, '0'); // Pega o mês (adicionando 1, pois começa em 0) e adiciona zero à esquerda
    const year = originalDate2.getFullYear(); // Pega o ano
    const hours = String(originalDate2.getHours()).padStart(2, '0'); // Pega as horas
    const minutes = String(originalDate2.getMinutes()).padStart(2, '0'); // Pega os minutos
    const seconds = String(originalDate2.getSeconds()).padStart(2, '0'); // Pega os segundos

    // Combina tudo no formato 'dd-mm-yyyy hh:mm:ss'
    const formattedDate2 = `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    dt = formattedDate2; // Atribui o formato final à variável dt
    return dt;
  }

  function formatDate2(dt) {

    const originalDate = dt;
    const formattedDate = new Date(originalDate).toISOString().slice(0, 19).replace('T', ' ');
    dt = formattedDate;

    const originalDate2 = new Date(dt);
    const day = String(originalDate2.getDate()).padStart(2, '0'); // Pega o dia e adiciona zero à esquerda, se necessário
    const month = String(originalDate2.getMonth() + 1).padStart(2, '0'); // Pega o mês (adicionando 1, pois começa em 0) e adiciona zero à esquerda
    const year = originalDate2.getFullYear(); // Pega o ano
    const hours = String(originalDate2.getHours()).padStart(2, '0'); // Pega as horas
    const minutes = String(originalDate2.getMinutes()).padStart(2, '0'); // Pega os minutos
    const seconds = String(originalDate2.getSeconds()).padStart(2, '0'); // Pega os segundos

    // Combina tudo no formato 'dd-mm-yyyy hh:mm:ss'
    const formattedDate2 = `${day}-${month}-${year}`;
    dt = formattedDate2; // Atribui o formato final à variável dt
    return dt;
  }

  const fetchVendedores = async () => {
    try {
      const retorno = await api.get('/usuarios', {
        params: {
          "instancia": `${instancia}`
        }
      })
      setVendedores(retorno.data);
    } catch (error) {

    }
  }

  // Função para buscar pedidos com base nos filtros
  const fetchPedidos = async ({ status, condicaoPagamento, vendedor, tipo }) => {

    if (!selectedPeriodo) return;

    const hoje = new Date();
    let inicio, fim;

    switch (selectedPeriodo) {
      case 'hoje':
        inicio = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
        fim = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
        inicio.setHours(0, 0, 0, 0);
        fim.setHours(23, 59, 59, 999);
        break;
      case 'semana':
        // Cria uma cópia da data atual para não modificar a original
        const primeiroDiaSemana = new Date(hoje);
        // Obtém o primeiro dia da semana (domingo = 0)
        primeiroDiaSemana.setDate(hoje.getDate() - hoje.getDay());
        primeiroDiaSemana.setHours(0, 0, 0, 0);

        // Cria uma cópia para o último dia
        const ultimoDiaSemana = new Date(primeiroDiaSemana);
        ultimoDiaSemana.setDate(primeiroDiaSemana.getDate() + 6);
        ultimoDiaSemana.setHours(23, 59, 59, 999);

        inicio = primeiroDiaSemana;
        fim = ultimoDiaSemana;
        break;
      case 'mes':
        inicio = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
        fim = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);
        break;
      case 'mesAnterior':
        inicio = new Date(hoje.getFullYear(), hoje.getMonth() - 1, 1);
        fim = new Date(hoje.getFullYear(), hoje.getMonth(), 0);
        break;
      case '2mesAnterior':
        inicio = new Date(hoje.getFullYear(), hoje.getMonth() - 2, 1);
        fim = new Date(hoje.getFullYear(), hoje.getMonth() - 1, 0);
        break;
      case 'todos':
      default:
        inicio = new Date('2000-01-01');
        fim = new Date('2050-01-01');
        break;
    }

    setDataI(inicio);
    setDataF(fim)

    setIsLoading(true);

    try {
      const response = await api.get('/pedidos', {
        params: {
          dataI: new Date(inicio).toISOString().split("T")[0],
          dataF: new Date(fim).toISOString().split("T")[0],
          status,
          "vendedor": selectedVendedor,
          "condPagto": condicaoPagamento,
          "instancia": `${instancia}`,
          tipo: tipo,
          fiscal: isFiscal
        }
      });
      setPedidos(response.data);

      // Atualiza os contadores de acordo com o status retornado
      let pedAberto = 0;
      let pedConcluido = 0;
      let fiscais = 0;
      let total = 0;

      // Alimenta os dados no setSummaryData
      setSummaryData({
        pedidosAbertos: 0,
        pedidosConcluidos: 0,
        docsFiscais: 0,
        valorTotal: 0
      });

      for (const pedido of response.data) {
        total += Number(pedido.VALOR_TOTAL);
        if (pedido.STATUS.toUpperCase() !== 'PENDENTE') {
          pedAberto += 1;
        }
        if (pedido.STATUS.toUpperCase() === 'CANCELADA') {
          pedConcluido += 1;
        }
        if (pedido.TIPO_DOC_FISCAL !== 'N' && pedido.STATUS.toUpperCase() !== 'CANCELADA') {
          fiscais += 1;
        }

      }

      setSummaryData({
        pedidosAbertos: pedAberto,
        pedidosConcluidos: pedConcluido,
        valorTotal: total,
        docsFiscais: fiscais
      });

      setIsLoading(false);
      setCurrentPage(1);

    } catch (error) {
      console.error('Erro ao buscar pedidos:', error);
      setIsLoading(false);
    }

  };

  // Função para buscar os cheques
  const fetchCheques = async ({ selectedPeriodo, status }) => {
    if (!selectedPeriodo) return;

    let inicio;
    let fim;
    const hoje = new Date();

    switch (selectedPeriodo) {
      case 'hoje': {
        const data = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
        inicio = data.toISOString().split('T')[0];
        fim = data.toISOString().split('T')[0];
        break;
      }

      case 'semana': {
        const primeiroDiaSemana = new Date(hoje);
        primeiroDiaSemana.setDate(hoje.getDate() - hoje.getDay());
        primeiroDiaSemana.setHours(0, 0, 0, 0);

        const ultimoDiaSemana = new Date(primeiroDiaSemana);
        ultimoDiaSemana.setDate(primeiroDiaSemana.getDate() + 6);
        ultimoDiaSemana.setHours(23, 59, 59, 999);

        inicio = primeiroDiaSemana.toISOString().split('T')[0];
        fim = ultimoDiaSemana.toISOString().split('T')[0];
        break;
      }

      case 'mes': {
        const ini = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
        const f = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);

        inicio = ini.toISOString().split('T')[0];
        fim = f.toISOString().split('T')[0];
        break;
      }

      case 'mesAnterior': {
        const ini = new Date(hoje.getFullYear(), hoje.getMonth() - 1, 1);
        const f = new Date(hoje.getFullYear(), hoje.getMonth(), 0);

        inicio = ini.toISOString().split('T')[0];
        fim = f.toISOString().split('T')[0];
        break;
      }

      case 'todos':
      default:
        inicio = '2000-01-01';
        fim = '2050-01-01';
        break;
    }

    setIsLoading(true);

    try {
      const cheques = await api.get('/cheques', {
        params: {
          dataI: inicio,
          dataF: fim,
          status: status.toUpperCase(),
          cliente: 0,
          instancia: `${instancia}`,
          pagina: 0
        }
      });

      setCheques(cheques.data.chequesFormatados);

      // Atualiza os contadores de acordo com o status retornado
      let chequeBaixado = 0;
      let chequePendente = 0;
      let totalGeral = 0;
      let totalBaixado = 0;
      let totalPendente = 0;

      for (const cheque of cheques.data.chequesFormatados) {
        totalGeral += Number(cheque.VALOR);
        if (cheque.STATUS.toUpperCase() !== 'PENDENTE') {
          chequePendente += 1;
          totalPendente += cheque.VALOR;
        }
        if (cheque.STATUS.toUpperCase() === 'BAIXADO') {
          chequeBaixado += 1;
          totalBaixado += cheque.VALOR;
        }
      }

      setTotalCheque(totalGeral);
      setIsLoading(false);
      setCurrentPage(1);

    } catch (error) {

    } finally {
      setIsLoading(false);
    }

  }

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/');
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value.toUpperCase());
    setCurrentPage(1);
  };

  const handleBaixarXmls = async () => {
    try {
      const urls = notasFiscais
        .map((nota) => nota.url_consulta + nota.caminhoXml)
        .filter(Boolean);

      if (urls.length === 0) {
        alert('Nenhum XML disponível.');
        return;
      }

      setCarregandoZip(true); // 💡 Inicia o carregamento

      const response = await api.post('/notas/xml/download-zip',
        urls,
        {
          responseType: 'blob',
        }
      );

      const blob = new Blob([response.data], { type: 'application/zip' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'xmls.zip';
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (erro) {
      console.error('Erro no download:', erro);
      alert('Erro ao baixar os arquivos.');
    } finally {
      setCarregandoZip(false); // ✅ Finaliza o carregamento
    }
  };

  const handleImprimir = async () => {

    try {
      setCarregandoZip(true); // 💡 Inicia o carregamento
      let inicio;
      let fim;
      const hoje = new Date();

      switch (selectedPeriodo) {
        case 'hoje': {
          const data = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
          inicio = data.toISOString().split('T')[0];
          fim = data.toISOString().split('T')[0];
          break;
        }

        case 'semana': {
          const primeiroDiaSemana = new Date(hoje);
          primeiroDiaSemana.setDate(hoje.getDate() - hoje.getDay());
          primeiroDiaSemana.setHours(0, 0, 0, 0);

          const ultimoDiaSemana = new Date(primeiroDiaSemana);
          ultimoDiaSemana.setDate(primeiroDiaSemana.getDate() + 6);
          ultimoDiaSemana.setHours(23, 59, 59, 999);

          inicio = primeiroDiaSemana.toISOString().split('T')[0];
          fim = ultimoDiaSemana.toISOString().split('T')[0];
          break;
        }

        case 'mes': {
          const ini = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
          const f = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);

          inicio = ini.toISOString().split('T')[0];
          fim = f.toISOString().split('T')[0];
          break;
        }

        case 'mesAnterior': {
          const ini = new Date(hoje.getFullYear(), hoje.getMonth() - 1, 1);
          const f = new Date(hoje.getFullYear(), hoje.getMonth(), 0);

          inicio = ini.toISOString().split('T')[0];
          fim = f.toISOString().split('T')[0];
          break;
        }

        case '2mesAnterior': {
          const ini = new Date(hoje.getFullYear(), hoje.getMonth() - 2, 1);
          const f = new Date(hoje.getFullYear(), hoje.getMonth() - 1, 0);

          inicio = ini.toISOString().split('T')[0];
          fim = f.toISOString().split('T')[0];
          break;
        }

        case 'todos':
        default:
          inicio = '2000-01-01';
          fim = '2050-01-01';
          break;
      }
      let tipo = 'todos'
      if (activeTab === 'notasFiscais') {
        console.log(selectedTipo.toLowerCase());
        if (selectedTipo.toLowerCase() !== 'todos') {
          tipo = selectedTipo.toUpperCase();
        }
      } else {
        tipo = selectedTipo;
      }

      const dti = inicio;
      const dtf = fim

      const inst = process.env.REACT_APP_INSTANCIA;

      const filtro = {
        dataI: `${dti} 00:00:00`,
        dataF: `${dtf} 23:59:59`,
        status: selectedStatus,
        condicaoPagamento: selectedCondicaoPagamento,
        vendedor: selectedVendedor,
        tipo: tipo,
        instancia: inst
      }

      const retorno = await api.post('/pedidos/relatorio', filtro);
      if (retorno && retorno?.data) {
        window.open(url_backend + '/' + retorno.data, '_blank');
      } else {
        alert('Relatório não criado');
      }

    } catch (error) {

    } finally {
      setCarregandoZip(false); // ✅ Finaliza o carregamento
    }
  }

  const handleInutiliza = async (data) => {
    try {
      setCarregandoZip(true); // 💡 Inicia o carregamento
      const obj = {
        serie: data.serie,
        numero: data.numero,
        justificativa: data.justificativa || 'Inutilização de numeros.'
      }

      const retorno = await api.post('/notas/inutilizacao', obj);

      if (retorno && retorno?.data) {
        alert(retorno.data.status_sefaz + ' - ' + retorno.data.mensagem_sefaz);
      } else {
        alert('Retina não disponivel: ' + retorno);
      }
    } catch (error) {

    } finally {
      setCarregandoZip(false); // ✅ Finaliza o carregamento
      setIsInutilizacaoModalOpen(false);
    }
  }

  const handleGerarBoleto = (pedido) => {
    setSelectedPedidoId(pedido);
    setIsBoletoModalOpen(true);
  };

  const handleGerarNFe = (pedido) => {
    setSelectedPedidoId(pedido);
    setIsConfirmModalOpen(true);
    showConfirmModal('Confirma a geração da NFe ?', 'NFE')
  };


  const handleGerarNFCe = (pedido) => {
    setSelectedPedidoId(pedido);
    setIsBoletoModalOpen(true);
  };

  // Adicione essa função para fechar o modal
  const closeBoletoModal = () => {
    setIsBoletoModalOpen(false);
    setSelectedPedidoId(null);
  };

  const handleEnviarEmail = async (pedidoId, tipoDoc, urlConsulta, pdfArquivo, sta, caminhoPdf, email, caminhoXml) => {
    // Encontra a posição de "/public" e pega dali para frente
    const resultado = caminhoPdf.substring(caminhoPdf.indexOf("/public"));
    const inst = process.env.REACT_APP_INSTANCIA;
    const url_backend = process.env.REACT_APP_API_BACKEND;

    const requisicao = {
      pedido: pedidoId,
      caminhoAbsoluto: caminhoPdf,
      caminhoAbsolutoXml: caminhoXml,
      caminhoHttp: url_backend + resultado,
      destinatario: email,
      assunto: 'PDF da Nota Fiscal Eletrônica - Pedido ' + pedidoId,
      corpo: `
            <h3>Nota Fiscal Eletrônica</h3>
            <p>Prezado cliente,</p>
            <p>Segue em anexo a Nota Fiscal Eletrônica do seu pedido.</p>
            <p><strong>Número do Pedido:</strong> ${pedidoId} </p>
            <p>Atenciosamente,<br>Equipe ${inst}</p>
        `
    };

    setIsLoading(true);
    try {
      const chamar = await api.post('/pedidoEmail', requisicao);
      const retorno = chamar.data;
      if (retorno.sucesso) {
        alert('Email enviado com sucesso!');
        // Limpar formulário ou redirecionar
      } else {
        console.log(retorno.erro);

        alert('Erro: ' + retorno.erro);
      }
    } catch (error) {
      console.log(error);
      alert(error);
    } finally {
      setIsLoading(false);
    }

  };

  const handleGerarNota = async (pedidoId, tipoDoc, urlConsulta, pdfArquivo, sta, caminhoPdf, chave_nfe) => {
    // console.log(pedidoId, tipoDoc, urlConsulta, pdfArquivo, sta, caminhoPdf, chave_nfe);
    let tpDoc = tipoDoc.toUpperCase();
    let st = sta.toUpperCase();
    alert(tpDoc)
    if (tpDoc === "N") {
      // Aqui você implementaria a lógica para gerar uma nota fiscal
      alert(`Gerar nota para o pedido ${pedidoId}`);
    } else if (tpDoc === "NFE") {
      if (!pdfArquivo || pdfArquivo.trim() === 'undefined' || pdfArquivo.trim() === '') {
        // A chave está faltando, é a string 'undefined' ou é vazia/só espaços
        const obj = { ref: chave_nfe, token: '', cod_pedido_oficial: pedidoId, instancia, tipo: tpDoc }
        const response = await api.post('/consultaDocumento', obj);
        window.open(urlConsulta + response?.data?.caminho_danfe, '_blank');
      } else {
        window.open(urlConsulta + pdfArquivo, '_blank');
      }
    } else if (tpDoc === "NFCE") {
      if (st === 'CANCELADA') {
        window.open(process.env.REACT_APP_API_BACKEND + caminhoPdf.split(`/${instancia}`)[1], '_blank');
      } else {
        window.open('https://api.focusnfe.com.br' + pdfArquivo, '_blank');
      }
    } else if (tpDoc === "CANCELADA") {
      window.open('https://api.focusnfe.com.br' + pdfArquivo, '_blank');
    } else {
      alert('Documento não gerado ')
    }
  };

  // Filtragem de dados com base na pesquisa
  const getFilteredData = () => {
    switch (activeTab) {
      case 'pedidos':
        return pedidos.filter(pedido => {
          const numero = String(pedido.COD_PEDIDO || "0"); // Converte COD_PEDIDO para string
          const cliente = String(pedido.NOME || "0"); // Converte COD_CLIENTE para string
          const status = pedido.STATUS?.toLowerCase() || ""; // STATUS já está validado como string
          const caminho_pdf = pedido.CAMINHO_PDF?.toLowerCase() || "";
          const data = pedido.DATA_PEDIDO || "2025-03-21";
          const valor = pedido.VALOR_TOTAL || 0;
          const chave_nfe = pedido.CHAVE_NFE || "";

          return numero.includes(searchTerm) ||
            cliente.includes(searchTerm) ||
            data.includes(searchTerm) ||
            valor.includes(searchTerm) ||
            caminho_pdf.includes(searchTerm) ||
            chave_nfe.includes(searchTerm) ||
            status.includes(searchTerm.toLowerCase());
        });
      case 'boletos':
        return boletos.filter(boleto =>
          boleto.numero.toLowerCase().includes(searchTerm.toLowerCase()) ||
          boleto.cliente.toLowerCase().includes(searchTerm.toLowerCase()) ||
          boleto.status.toLowerCase().includes(searchTerm.toLowerCase())
        );
      case 'notasFiscais':
        return notasFiscais.filter(nota => {
          // Converte o termo de busca para lowercase para comparação sem case sensitivity
          const term = searchTerm.toLowerCase();

          // Cria uma função auxiliar para verificar com segurança
          const safeIncludes = (value) => {
            if (value === null || value === undefined) return false;
            return String(value).toLowerCase().includes(term);
          };

          // Verifica cada propriedade com os nomes corretos
          return safeIncludes(nota.id) ||
            safeIncludes(nota.numero) ||
            safeIncludes(nota.pedido) ||
            safeIncludes(nota.cliente) ||
            safeIncludes(nota.valor) ||
            safeIncludes(nota.emissao) ||
            safeIncludes(nota.status) ||
            safeIncludes(nota.tipo_doc) ||
            safeIncludes(nota.url_consulta) ||
            safeIncludes(nota.pdfNf) ||
            safeIncludes(nota.caminhoPdf) ||
            safeIncludes(nota.chave_nfe) ||
            safeIncludes(nota.caminhoXml);
        });

      case 'cheques':
        return cheques.filter(cheque => {
          // Converte o termo de busca para lowercase para comparação sem case sensitivity
          const term = searchTerm.toLowerCase();

          // Cria uma função auxiliar para verificar com segurança
          const safeIncludes = (value) => {
            if (value === null || value === undefined) return false;
            return String(value).toLowerCase().includes(term);
          };

          // Verifica cada propriedade com os nomes corretos
          return safeIncludes(cheque.COD_CHEQUE) ||
            safeIncludes(cheque.nome) ||
            safeIncludes(cheque.CNPJ_CPF) ||
            safeIncludes(cheque.NUMERO) ||
            safeIncludes(cheque.VALOR) ||
            safeIncludes(cheque.EMISSAO) ||
            safeIncludes(cheque.STATUS) ||
            safeIncludes(cheque.BANCO) ||
            safeIncludes(cheque.VENCIMENTO);
        });

      default:
        return [];
    }
  };

  const filteredData = getFilteredData();

  const handleAbrirModal = (pedidoId, tipoDoc, urlConsulta, pdfArquivo, nota, operacao) => {
    console.log(pedidoId, tipoDoc, urlConsulta, pdfArquivo, nota, operacao);
    let tpDoc = tipoDoc?.toUpperCase() || '';
    if (tpDoc !== 'N') {
      setSelectedNota({
        pedidoId,
        numero: nota.numero,
        cliente: nota.cliente,
        emissao: nota.emissao,
        tipoDoc: tpDoc,
        urlConsulta,
        pdfArquivo
      });
      setModalOperacao(operacao);
      setIsNotaModalOpen(true);
    } else {
      alert('Documento não gerado ou não disponível');
    }
  };

  const handleVerXml = (baseUrl, url) => {
    if (url) {
      window.open(baseUrl + url, '_blank');
    } else {
      alert('xml nao encontrado')
    }
  }

  const handleSalvar = async (cheque) => {
    try {
      const obj = {
        cod_usuario: 124,
        cod_cliente: 10547,
        cnpj_cpf: cheque.cpfCnpj,
        valor: cheque.valor,
        banco: cheque.banco,
        numero: cheque.numero,
        emissao: cheque.emissao,
        vencimento: cheque.vencimento,
        instancia: `${instancia}`,
        cod_cheque: cheque.cod_cheque
      }
      await api.post('/cheques', obj);
    } catch (error) {
      alert(error);
    }
  }

  // Lógica de paginação
  const itemsPerPage = 10;
  // const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentItems = filteredData.slice(startIndex, endIndex);

  // const itemsPerPage = 10;
  const totalPages = Math.ceil(getFilteredData().length / itemsPerPage);
  const paginatedData = getFilteredData().slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );


  if (isLoading && (!pedidos.length && !boletos.length && !notasFiscais.length)) {
    return <Loader fullScreen />;
  }

  const showConfirmModal = (message, action) => {
    setConfirmMessage(message);
    setConfirmAction(() => action);
    setIsConfirmModalOpen(true);
  };

  // quando usuário confirma
  const handleConfirm = async () => {
    setConfirmResult(true);   // Usuário clicou "Sim"
    setIsConfirmModalOpen(false);
    console.log('Usuário confirmou, gerar NFe para', currentSelectedItems);
    // Chamar api para gerar a nota
    try {
      const obj = {
        cod_pedido_oficial: currentSelectedItems[0],
        instancia: `${instancia}`,
        tipo: 'NFE',
      }
      const retorno = await api.post('/gerarNota', obj);
      console.log(retorno);
    } catch (error) {
      alert(error);
    }

  };

  // quando usuário cancela
  const handleCancel = () => {
    setConfirmResult(false);  // Usuário clicou "Não"
    setIsConfirmModalOpen(false);
  };

  // const handleBaixarCheque = async (id) => {
  //   try {
  //     await api.put(`/cheques/baixar/${id}/${instancia}`);
  //     alert('Cheque baixado com sucesso!');
  //     fetchCheques({ selectedPeriodo, status: selectedStatus }); // Atualizar lista
  //   } catch (error) {
  //     console.error('Erro ao baixar cheque:', error);
  //     alert('Erro ao baixar cheque.');
  //   }
  // };

  // const handleExcluirCheque = async (id) => {
  //   try {
  //     const retorno = await api.delete(`/cheques/${id}/${instancia}`);
  //     fetchCheques({ selectedPeriodo, status: selectedStatus });
  //   } catch (error) {
  //     console.error('Erro ao excluir cheque:', error);
  //     alert('Erro ao excluir cheque.');
  //   }
  // };

  // responsaveis pelos itens selecionados
  // ... (dentro do componente Home)

  // Função genérica para alternar a seleção de um item


  const toggleItemSelected = (itemId, currentSelectedItems, setSelectedItems) => {
    if (currentSelectedItems.includes(itemId)) {
      setSelectedItems(currentSelectedItems.filter((id) => id !== itemId));
    } else {
      setSelectedItems([...currentSelectedItems, itemId]);
    }
  };

  // Função genérica para selecionar/desselecionar todos
  const toggleSelectAll = (allItems, currentSelectedItems, setSelectedItems) => {
    if (currentSelectedItems.length === allItems.length && allItems.length > 0) {
      setSelectedItems([]); // Desseleciona todos
    } else {
      setSelectedItems(allItems.map((item) => item.COD_PEDIDO || item.id)); // Pega o ID de todos os itens
    }
  };

  // Funções específicas para cada tipo de dados (chamadas a partir dos eventos)
  const handleTogglePedidoSelected = (pedidoId) => {
    toggleItemSelected(pedidoId, selectedPedidos, setSelectedPedidos);
  };

  const handleToggleBoletoSelected = (boletoId) => {
    toggleItemSelected(boletoId, selectedBoletos, setSelectedBoletos);
  };

  const handleToggleNotaFiscalSelected = (notaId) => {
    toggleItemSelected(notaId, selectedNotasFiscais, setSelectedNotasFiscais);
  };

  const handleToggleChequeSelected = (chequeId) => {
    toggleItemSelected(chequeId, selectedCheques, setSelectedCheques);
  };

  const handleSelectAllPedidos = () => {
    toggleSelectAll(getFilteredData(), selectedPedidos, setSelectedPedidos);
  };

  const handleSelectAllBoletos = () => {
    toggleSelectAll(getFilteredData(), selectedBoletos, setSelectedBoletos);
  };

  const handleSelectAllNotasFiscais = () => {
    toggleSelectAll(getFilteredData(), selectedNotasFiscais, setSelectedNotasFiscais);
  };

  const handleSelectAllCheques = () => {
    toggleSelectAll(getFilteredData(), selectedCheques, setSelectedCheques);
  };


  // Determine qual array de seleção usar com base na aba ativa
  const currentSelectedItems = (() => {
    switch (activeTab) {
      case 'pedidos':
        return selectedPedidos;
      case 'boletos':
        return selectedBoletos;
      case 'notasFiscais':
        return selectedNotasFiscais;
      case 'cheques':
        return selectedCheques;
      default:
        return [];
    }
  })();

  // Determine a função de toggle para um único item com base na aba ativa
  const currentToggleItem = (() => {
    switch (activeTab) {
      case 'pedidos':
        return handleTogglePedidoSelected;
      case 'boletos':
        return handleToggleBoletoSelected;
      case 'notasFiscais':
        return handleToggleNotaFiscalSelected;
      case 'cheques':
        return handleToggleChequeSelected;
      default:
        return () => { };
    }
  })();

  // Determine a função de selecionar todos com base na aba ativa
  const currentSelectAll = (() => {
    switch (activeTab) {
      case 'pedidos':
        return handleSelectAllPedidos;
      case 'boletos':
        return handleSelectAllBoletos;
      case 'notasFiscais':
        return handleSelectAllNotasFiscais;
      case 'cheques':
        return handleSelectAllCheques;
      default:
        return () => { };
    }
  })();

  // Determine se o checkbox "selecionar todos" deve estar marcado
  const isAllSelected = paginatedData.length > 0 && paginatedData.every(item => currentSelectedItems.includes(item.COD_PEDIDO || item.id));

  return (
    <HomeContainer>

      <HomeHeader>
        <Logo>Finance Manager</Logo>
        {userData && (
          <UserSection>

            <Button
              onClick={() => navigate('/finance')}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                textDecoration: 'none',
                color: '#6c5ce7',
                fontSize: '16px',
                fontWeight: '700',
                marginRight: '30px'
              }}
            >
              Financeiro
            </Button>


            <Button
              onClick={() => navigate('/contacorrente')}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                textDecoration: 'none',
                color: '#6c5ce7',
                fontSize: '16px',
                fontWeight: '700',
                marginRight: '30px'
              }}
            >
              Conta Corrente
            </Button>

            <Button
              onClick={() => navigate('/fornecedor')}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                textDecoration: 'none',
                color: '#6c5ce7',
                fontSize: '16px',
                fontWeight: '700',
                marginRight: '30px'
              }}
            >
              Fornecedor
            </Button>

            <Button
              onClick={() => navigate('/banco/cheques')}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                textDecoration: 'none',
                color: '#6c5ce7',
                fontSize: '16px',
                fontWeight: '700',
                marginRight: '100px'
              }}
            >
              Cheques a Pagar
            </Button>

            <UserInfo>
              <UserName>{userData.nome}</UserName>
              <LogoutButton onClick={handleLogout}>Sair</LogoutButton>
            </UserInfo>
            <UserAvatar>{userData.iniciais}</UserAvatar>
          </UserSection>
        )}
      </HomeHeader>

      <ContentContainer>

        {/* Cards de Status */}
        {activeTab !== 'cheques' && (
          <StatusCardsContainer>
            <StatusCard
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
            >
              <CardHeader>
                <CardTitle>PEDIDOS SINCRONIZADOS</CardTitle>
                <CardIcon bgColor="#fff8e6" iconColor="#f39c12">📋</CardIcon>
              </CardHeader>
              <CardValue>{summaryData.pedidosAbertos}</CardValue>
              <CardDescription>Pedidos em processamento</CardDescription>
            </StatusCard>

            <StatusCard
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: 0.2 }}
            >
              <CardHeader>
                <CardTitle>DOCUMENTOS GERADOS</CardTitle>
                <CardIcon bgColor="#e6f7ed" iconColor="#2ecc71">✓</CardIcon>
              </CardHeader>
              <CardValue>{summaryData.docsFiscais}</CardValue>
              <CardDescription>NFe e NFCe</CardDescription>
            </StatusCard>

            <StatusCard
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: 0.1 }}
            >
              <CardHeader>
                <CardTitle>DOCS CANCELADOS</CardTitle>
                <CardIcon bgColor="#e6e6fa" iconColor="#6c5ce7">❌</CardIcon>
              </CardHeader>
              <CardValue>{summaryData.pedidosConcluidos}</CardValue>
              <CardDescription>NFe e NFCe canceladas</CardDescription>
            </StatusCard>

            <StatusCard
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: 0.3 }}
            >
              <CardHeader>
                <CardTitle>VALOR TOTAL</CardTitle>
                <CardIcon bgColor="#e6f7ed" iconColor="#2ecc71">R$</CardIcon>
              </CardHeader>
              <CardValue>{formatCurrency(summaryData.valorTotal)}</CardValue>
              <CardDescription>Total de transações no período</CardDescription>
            </StatusCard>

          </StatusCardsContainer>
        )}

        {/* Tabs para alternar entre Pedidos, Boletos e Notas Fiscais */}
        <TabsContainer>
          <Tab
            active={activeTab === 'pedidos'}
            onClick={() => setActiveTab('pedidos')}
          >
            Pedidos
          </Tab>
          <Tab
            active={activeTab === 'boletos'}
            onClick={() => setActiveTab('boletos')}
          >
            Boletos
          </Tab>
          <Tab
            active={activeTab === 'notasFiscais'}
            onClick={() => setActiveTab('notasFiscais')}
          >
            Notas Fiscais
          </Tab>
          <Tab
            active={activeTab === 'cheques'}
            onClick={() => setActiveTab('cheques')}
          >
            Cheques a Receber
          </Tab>
          <div
            style={{
              backgroundColor: '#696969',
              height: '30px',
              border: 'none',
              borderRadius: '10px',
              display: 'flex',          // Adicionado para usar flexbox
              justifyContent: 'center', // Centraliza horizontalmente
              alignItems: 'center',     // Centraliza verticalmente
              marginLeft: '10px',   // Adiciona 10 pixels de margem à esquerda
              marginRight: '10px',
            }}
          >
            <label style={{ color: 'white', marginLeft: '10px', marginRight: '10px' }}> {/* Adicionei a cor branca para o texto ficar visível */}
              Período selecionado: {formatDate2(dataI.toString())} à {formatDate2(dataF.toString())}
            </label>
          </div>
        </TabsContainer>

        {/* Filtros de período (apenas para a aba de Pedidos e Notas) */}
        {activeTab === 'pedidos' && (
          <>
            <FiltersContainer>
              <FilterButton
                active={selectedPeriodo === 'hoje'}
                onClick={() => { setSelectedPeriodo('hoje') }}
              >
                Hoje
              </FilterButton>
              <FilterButton
                active={selectedPeriodo === 'semana'}
                onClick={() => { setSelectedPeriodo('semana') }}
              >
                Esta Semana
              </FilterButton>
              <FilterButton
                active={selectedPeriodo === 'mes'}
                onClick={() => { setSelectedPeriodo('mes') }}
              >
                Este Mês
              </FilterButton>
              <FilterButton
                active={selectedPeriodo === 'mesAnterior'}
                onClick={() => { setSelectedPeriodo('mesAnterior') }}
              >
                Mês Anterior
              </FilterButton>
              <FilterButton
                active={selectedPeriodo === '2mesAnterior'}
                onClick={() => { setSelectedPeriodo('2mesAnterior') }}
              >
                2 Mês Antes
              </FilterButton>

              <span style={{ margin: '0 8px', color: '#666' }}>|</span>

              <AdvancedFiltersButton onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}>
                {showAdvancedFilters ? 'Ocultar filtros avançados ▲' : 'Mostrar filtros avançados ▼'}
              </AdvancedFiltersButton>

              <FilterButton
                active={isFiscal === 'S'}
                onClick={() => setIsFiscal(isFiscal === 'S' ? 'N' : 'S')}
              >
                Fiscal: {isFiscal === 'S' ? 'Sim' : 'Não'}
              </FilterButton>

              <label style={{ display: 'flex', alignItems: 'center', margin: '0 8px' }}>
                <input
                  type="checkbox"
                  checked={isFiscal === 'S'}
                  onChange={(e) => setIsFiscal(e.target.checked ? 'S' : 'N')}
                />
                <span style={{ marginLeft: '4px' }}>Fiscal</span>
              </label>

            </FiltersContainer>

            <AdvancedFiltersContainer show={showAdvancedFilters}>
              <FilterGroup>
                <FilterLabel>Condição de Pagamento</FilterLabel>
                <SelectFilter
                  value={selectedCondicaoPagamento}
                  onChange={(e) => setSelectedCondicaoPagamento(e.target.value)}
                >
                  <option value="todas">Todas</option>
                  {condicoesPagamento.map(condicao => (
                    <option key={condicao.id} value={condicao.id}>
                      {condicao.nome}
                    </option>
                  ))}
                </SelectFilter>
              </FilterGroup>

              <FilterGroup>
                <FilterLabel>Vendedor</FilterLabel>
                <SelectFilter
                  value={selectedVendedor}
                  onChange={(e) => setSelectedVendedor(e.target.value)}
                >
                  <option value="todos">Todos</option>
                  {vendedores.map(vendedor => (
                    <option key={vendedor.COD_USUARIO} value={vendedor.COD_USUARIO}>
                      {vendedor.NOME}
                    </option>
                  ))}
                </SelectFilter>
              </FilterGroup>

              <FilterGroup>
                <FilterLabel>Tipos</FilterLabel>
                <SelectFilter
                  value={selectedTipo}
                  onChange={(e) => setSelectedTipo(e.target.value)}
                >
                  {/* <option value="todos">Todos</option> */}
                  {tipos.map(tipo => (
                    <option key={tipo.id} value={tipo.descricao}>
                      {tipo.descricao}
                    </option>
                  ))}
                </SelectFilter>
              </FilterGroup>

            </AdvancedFiltersContainer>
          </>
        )}

        {activeTab === 'cheques' && (
          <>
            <FiltersContainer>
              <FilterButton
                active={selectedPeriodo === 'hoje'}
                onClick={() => { setSelectedPeriodo('hoje') }}
              >
                Hoje
              </FilterButton>
              <FilterButton
                active={selectedPeriodo === 'semana'}
                onClick={() => { setSelectedPeriodo('semana') }}
              >
                Esta Semana
              </FilterButton>
              <FilterButton
                active={selectedPeriodo === 'mes'}
                onClick={() => { setSelectedPeriodo('mes') }}
              >
                Este Mês
              </FilterButton>
              <FilterButton
                active={selectedPeriodo === 'mesAnterior'}
                onClick={() => { setSelectedPeriodo('mesAnterior') }}
              >
                Mês Anterior
              </FilterButton>
              <FilterButton
                active={selectedPeriodo === 'todos'}
                onClick={() => { setSelectedPeriodo('todos') }}
              >
                Todos
              </FilterButton>

              <span style={{ margin: '0 8px', color: '#666' }}>|</span>

              <FilterButton
                active={selectedStatus === 'todos'}
                onClick={() => setSelectedStatus('todos')}
              >
                Todos Status
              </FilterButton>

              <FilterButton
                active={selectedStatus === 'ABERTO'}
                onClick={() => setSelectedStatus('ABERTO')}
              >
                Abertos
              </FilterButton>
              <FilterButton
                active={selectedStatus === 'CONCLUIDO'}
                onClick={() => setSelectedStatus('CONCLUIDO')}
              >
                Baixados
              </FilterButton>

            </FiltersContainer>
          </>
        )}

        {/* Cabeçalho da seção com título e busca */}
        <SectionHeading>
          <SectionTitle>
            {activeTab === 'pedidos'
              ? 'Gerenciamento de Pedidos'
              : activeTab === 'boletos'
                ? 'Gerenciamento de Boletos'
                : activeTab === 'cheques'
                  ? 'Gerenciamento de cheques'
                  : 'Gerenciamento de Notas Fiscais'}

            {activeTab === 'cheques' && (
              <span style={{ marginLeft: '10rem', fontSize: '1.5rem', color: '#666' }}>
                Total: {formatCurrency(totalCheque)}
              </span>
            )}
          </SectionTitle>

          <FilterSection>

            {activeTab === 'notasFiscais' && (
              <Button
                style={{ width: 140, height: 35 }}
                variant="sucess"
                size="small"
                onClick={() => {
                  setIsInutilizacaoModalOpen(true);
                }}
                disabled={carregandoZip}
              >
                {carregandoZip ? (
                  <>
                    <Spinner style={{ marginRight: '8px' }} />
                    Gerando arquivos...
                  </>
                ) : (
                  '❌ Inutilização'
                )}
              </Button>
            )}

            {activeTab === 'notasFiscais' && (
              <Button
                style={{ width: 120, height: 35 }}
                variant="sucess"
                size="small"
                onClick={handleImprimir}
                disabled={carregandoZip}
              >
                {carregandoZip ? (
                  <>
                    <Spinner style={{ marginRight: '8px' }} />
                    Gerando arquivos...
                  </>
                ) : (
                  '📥 Imprimir '
                )}
              </Button>
            )}

            {activeTab === 'pedidos' && (
              <Button
                style={{ width: 150, height: 35 }}
                variant="sucess"
                size="small"
                onClick={handleImprimir}
                disabled={carregandoZip}
              >
                {carregandoZip ? (
                  <>
                    <Spinner style={{ marginRight: '8px' }} />
                    Gerando arquivos...
                  </>
                ) : (
                  '📥 Imprimir'
                )}
              </Button>
            )}

            {activeTab === 'notasFiscais' && (
              <Button
                style={{ width: 150, height: 35 }}
                variant="primary"
                size="small"
                onClick={handleBaixarXmls}
                disabled={carregandoZip}
              >
                {carregandoZip ? (
                  <>
                    <Spinner style={{ marginRight: '8px' }} />
                    Gerando arquivos...
                  </>
                ) : (
                  '📥 Gerar XMLs'
                )}
              </Button>
            )}

            <SearchInput
              type="text"
              placeholder="Buscar..."
              value={searchTerm}
              onChange={handleSearch}
            />
            {/* {activeTab === 'pedidos' && (
              <Button
                variant="primary"
                size="small"
              >
                Novo Pedido
              </Button>
            )} */}
            {activeTab === 'cheques' && (
              <Button
                variant="primary"
                size="small"
                onClick={() => {
                  setCurrentCheque(null);
                  setIsChequeModalOpen(true);
                }}
              >
                Novo Cheque
              </Button>
            )}

          </FilterSection>
        </SectionHeading>


        {/* Ações para itens selecionados */}
        {currentSelectedItems.length > 0 && (
          <div style={{ marginBottom: '16px', display: 'flex', gap: '8px' }}>
            {/* <Button primary onClick={() => alert(`Executar ação em ${currentSelectedItems.length} itens selecionados na aba ${activeTab}`)}>
              Executar Ação em {currentSelectedItems.length} Itens
            </Button> */}
            {/* Exemplo de outras ações, se houver */}
            {/* {activeTab === 'notasFiscais' && (
              <Button secondary onClick={() => alert('Baixar XMLs selecionados')}>
                Baixar XMLs Selecionados
              </Button>
            )} */}
            {activeTab === 'pedidos' && (
              <Button onClick={() => handleGerarBoleto(0)}>
                Gerar Boleto para Selecionados
              </Button>
            )}
            {activeTab === 'pedidos' && (
              <Button onClick={() => handleGerarNFe(0)}>
                Gerar NFe
              </Button>
            )}
            {activeTab === 'pedidos' && (
              <Button onClick={() => handleGerarNFCe(0)}>
                Gerar NFCe (Cupom)
              </Button>
            )}

            {/* Adicione outras ações conforme necessário para cada aba */}
          </div>
        )}


        {/* Tabela de dados */}

        <TableContainer>
          {isLoading ? (
            <EmptyState>
              <Loader /> Carregando dados...
            </EmptyState>
          ) : paginatedData.length === 0 ? (
            <EmptyState>Nenhum resultado encontrado.</EmptyState>
          ) : (
            <Table>
              <thead>
                <tr>
                  {activeTab === 'pedidos' && (
                    <>
                      <Th>
                        <input
                          type="checkbox"
                          onChange={currentSelectAll}
                          checked={isAllSelected}
                        />
                      </Th>
                      <Th>Pedido</Th>
                      <Th>Cliente</Th>
                      <Th>Data</Th>
                      <Th>Valor</Th>
                      {/* <Th>Status</Th> */}
                      <Th>Tipo Doc</Th>
                      <Th style={{ textAlign: 'center' }}>Ações</Th>
                    </>
                  )}
                  {activeTab === 'boletos' && (
                    <>
                      <Th>Número</Th>
                      <Th>Pedido</Th>
                      <Th>Cliente</Th>
                      <Th>Valor</Th>
                      <Th>Vencimento</Th>
                      <Th>Status</Th>
                      <Th>Ações</Th>
                    </>
                  )}
                  {activeTab === 'notasFiscais' && (
                    <>
                      <Th>Nota</Th>
                      <Th>Pedido</Th>
                      <Th>Cliente</Th>
                      <Th>Valor</Th>
                      <Th>Emissão</Th>
                      <Th>Status</Th>
                      <Th>Tipo</Th>
                      <Th>Ações</Th>
                    </>
                  )}
                  {activeTab === 'cheques' && (
                    <>
                      <Th>Banco</Th>
                      <Th>Agência</Th>
                      <Th>Conta</Th>
                      <Th>Número</Th>
                      <Th>Emitente</Th>
                      <Th>Valor</Th>
                      <Th>Vencimento</Th>
                      <Th>Status</Th>
                      <Th>Ações</Th>
                    </>
                  )}
                </tr>
              </thead>
              <tbody>
                {paginatedData.map((item) => {
                  const itemId = item.COD_PEDIDO || item.id; // Garante que você tem um ID para a seleção
                  const isItemSelected = currentSelectedItems.includes(itemId);
                  return (
                    <tr key={itemId}>

                      {activeTab === 'pedidos' && (
                        <>
                          <Td>
                            <input
                              type="checkbox"
                              checked={isItemSelected}
                              onChange={() => currentToggleItem(itemId)}
                            />
                          </Td>
                          <Td>{item.COD_PEDIDO}</Td>
                          <Td>{item.NOME}</Td>
                          <Td>{formatDate2(item.DATA_PEDIDO)}</Td>
                          <Td>{formatCurrency(item.VALOR_TOTAL)}</Td>
                          {/* <Td>
                            <StatusBadge status={item.STATUS}>
                              {item.STATUS}
                            </StatusBadge>
                          </Td> */}
                          <Td>{item.TIPO_DOC_FISCAL}</Td>
                          <Td style={{ textAlign: 'center' }}>
                            <ActionButtonGroup>
                              <ActionButton
                                onClick={() => handleGerarBoleto(item.COD_PEDIDO)}
                                title="Gerar Boleto"
                              // disabled={!item.temBoleto}
                              >
                                💸 Boleto
                              </ActionButton>

                              {/* <ActionButton
                                onClick={() =>
                                  handleGerarNota(
                                    item.COD_PEDIDO,
                                    item.TIPO_DOC_FISCAL,
                                    item.URL_CONSULTA,
                                    item.PDFNFCe,
                                    item.STATUS,
                                    item.CAMINHO_PDF
                                  )
                                }
                                title="Visualizar Nota"
                              >
                                📄 PDF
                              </ActionButton> */}
                              <ActionButton
                                onClick={() =>
                                  handleEnviarEmail(
                                    item.COD_PEDIDO,
                                    item.TIPO_DOC_FISCAL,
                                    item.URL_CONSULTA,
                                    item.PDFNFCe,
                                    item.STATUS,
                                    item.CAMINHO_PDF,
                                    item.EMAIL,
                                    item.CAMINHO_XML
                                  )
                                }
                                title="Enviar por Email"
                              >
                                📧 e-Mail
                              </ActionButton>
                            </ActionButtonGroup>
                          </Td>
                        </>
                      )}
                      {/* Repita o padrão para as outras abas (boletos, notasFiscais, cheques) */}
                      {activeTab === 'boletos' && (
                        <>
                          <Td>{item.numero}</Td>
                          <Td>{item.pedido}</Td>
                          <Td>{item.cliente}</Td>
                          <Td>{formatCurrency(item.valor)}</Td>
                          <Td>{formatDate2(item.vencimento)}</Td>
                          <Td>
                            <StatusBadge status={item.status}>
                              {item.status}
                            </StatusBadge>
                          </Td>
                          {/* <Td>
                            <ActionButtonGroup>
                              <ActionButton
                                onClick={() => handleGerarBoleto(item.id)} // Boleto já possui um ID
                                title="Visualizar Boleto"
                              >
                                👁️ PDF
                              </ActionButton>
                            </ActionButtonGroup>
                          </Td> */}
                        </>
                      )}
                      {activeTab === 'notasFiscais' && (
                        <>
                          <Td>{item.numero}</Td>
                          <Td>{item.pedido}</Td>
                          <Td>{item.cliente}</Td>
                          <Td>{formatCurrency(item.valor)}</Td>
                          <Td>{formatDate2(item.emissao)}</Td>
                          <Td>
                            <StatusBadge status={item.status}>
                              {item.status}
                            </StatusBadge>
                          </Td>
                          <Td>{item.tipo_doc}</Td>
                          <Td>
                            <ActionButtonGroup>
                              {item.status !== 'CANCELADA' && (
                                <ActionButton
                                  onClick={() => handleAbrirModal(item.pedido, item.tipo_doc, item.url_consulta, item.caminhoPdf, item, 'cancelar')}
                                  title="Cancelar"
                                >
                                  ⭕ Cancelar
                                </ActionButton>
                              )}
                              <ActionButton
                                onClick={() =>
                                  handleGerarNota(
                                    item.id,
                                    item.tipo_doc,
                                    item.url_consulta,
                                    item.pdfNf,
                                    item.status,
                                    item.caminhoPdf,
                                    item.numero
                                  )
                                }
                                title="Visualizar Nota"
                              >
                                👁️ PDF
                              </ActionButton>
                              <ActionButton
                                onClick={() =>
                                  handleEnviarEmail(
                                    item.id,
                                    item.tipo_doc,
                                    item.url_consulta,
                                    item.pdfNf,
                                    item.status,
                                    item.caminhoPdf,
                                    item.email,
                                    item.caminhoXmlAbsoluto
                                  )
                                }
                                title="Enviar por Email"
                              >
                                📧 E-Mail
                              </ActionButton>
                            </ActionButtonGroup>
                          </Td>
                        </>
                      )}
                      {activeTab === 'cheques' && (
                        <>
                          <Td>{item.BANCO}</Td>
                          <Td>{item.AGENCIA}</Td>
                          <Td>{item.CONTA}</Td>
                          <Td>{item.NUMERO_CHEQUE}</Td>
                          <Td>{item.EMITENTE}</Td>
                          <Td>{formatCurrency(item.VALOR)}</Td>
                          <Td>{formatDate2(item.VENCIMENTO)}</Td>
                          <Td>
                            <StatusBadge status={item.STATUS}>
                              {item.STATUS}
                            </StatusBadge>
                          </Td>
                          <Td>
                            <ActionButtonGroup>
                              <ActionButton
                                // onClick={() => handleOpenChequeModal(item)}
                                title="Editar Cheque"
                              >
                                ✏️
                              </ActionButton>
                              <ActionButton
                                // onClick={() =>
                                //   handleConfirmDeleteCheque(item.ID_CHEQUE)
                                // }
                                title="Excluir Cheque"
                              >
                                🗑️
                              </ActionButton>
                            </ActionButtonGroup>
                          </Td>
                        </>
                      )}

                    </tr>
                  );
                })}
              </tbody>
            </Table>
          )}
        </TableContainer>

        {/* Paginação */}
        {filteredData.length > itemsPerPage && (
          <PaginationContainer>
            <PaginationInfo>
              Mostrando {startIndex + 1} a {Math.min(endIndex, filteredData.length)} de {filteredData.length} registros
            </PaginationInfo>

            <PaginationButtons>
              <PaginationButton
                onClick={() => setCurrentPage(1)}
                disabled={currentPage === 1}
              >
                Primeira
              </PaginationButton>

              <PaginationButton
                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                Anterior
              </PaginationButton>

              {Array.from({ length: Math.min(3, totalPages) }, (_, i) => {
                // Lógica para mostrar as páginas próximas à atual
                let pageNum;
                if (totalPages <= 3) {
                  pageNum = i + 1;
                } else if (currentPage <= 2) {
                  pageNum = i + 1;
                } else if (currentPage >= totalPages - 1) {
                  pageNum = totalPages - 2 + i;
                } else {
                  pageNum = currentPage - 1 + i;
                }

                return (
                  <PaginationButton
                    key={pageNum}
                    active={currentPage === pageNum}
                    onClick={() => setCurrentPage(pageNum)}
                  >
                    {pageNum}
                  </PaginationButton>
                );
              })}

              <PaginationButton
                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
              >
                Próxima
              </PaginationButton>

              <PaginationButton
                onClick={() => setCurrentPage(totalPages)}
                disabled={currentPage === totalPages}
              >
                Última
              </PaginationButton>
            </PaginationButtons>
          </PaginationContainer>
        )}

      </ContentContainer>

      <BoletoModal
        isOpen={isBoletoModalOpen}
        onClose={closeBoletoModal}
        pedidoId={selectedPedidoId}
        selecionados={currentSelectedItems}
      />

      <NotaModal
        isOpen={isNotaModalOpen}
        onClose={() => setIsNotaModalOpen(false)}
        notaInfo={selectedNota}
        operacao={modalOperacao}
      />

      <ChequeModal
        isOpen={isChequeModalOpen}
        onClose={() => setIsChequeModalOpen(false)}
        onSave={(data) => {
          handleSalvar(data);
        }}
        initialData={currentCheque}
      />

      <InutilizacaoModal
        isOpen={isInutilizacaoModalOpen}
        onClose={() => setIsInutilizacaoModalOpen(false)}
        onSave={(data) => {
          handleInutiliza(data);
        }}
        initialData={currentCheque}
      />

      <ConfirmModal
        isOpen={isConfirmModalOpen}
        onClose={handleCancel}    // "Não"
        onConfirm={handleConfirm} // "Sim"
        message={confirmMessage}
        pedido={currentSelectedItems}
      />

    </HomeContainer>
  );
};

export default Home;